import React from 'react';
import { Controller } from 'react-hook-form';
import Select from 'react-select';

import { FormError, HelpText } from '@Forms/fields.jsx';

const MultiSelectField = ({
  control,
  error,
  helpText,
  label,
  name,
  rules,
  ...props
}) => {
  // resuable text field
  return (
    <div
      className={
        `sb-form-item-formgroup sb-form-item-multiselect ` +
        (error ? 'sb-form-item-error' : '')
      }
    >
      <label htmlFor={name}>{label}</label>
      <div className="sb-form-item-content">
        <Controller
          control={control}
          name={name}
          rules={rules}
          render={({ field, value, name, ref }) => (
            <Select
              name={field.name}
              inputRef={field.ref}
              isMulti
              className="basic-multi-select"
              classNamePrefix="select"
              onChange={(val) => field.onChange(val.map((v) => v.value))}
              defaultValue={
                field.value
                  ? field.value.map((v) =>
                      props.options.find((c) => c.value === v),
                    )
                  : []
              }
              {...props}
            />
          )}
        />
        {helpText && <HelpText message={helpText} />}
        {error && <FormError message={error.message} />}
      </div>
    </div>
  );
};

export default MultiSelectField;
